import React, { Component } from 'react'

import { TransitionContainer } from '../utility/GlobalComponents'
import { TabbedContainer, TabPane } from './TabbedContainer'
import { Alliance } from './guide-pages/Alliance'
import { Motes } from './guide-pages/Motes'
import { General } from './guide-pages/General'
import { TierList } from './guide-pages/TierList'


export default class Guides extends Component {

    render () {
        return (
            <TransitionContainer className='mv-guides-container'>
                <TabbedContainer panes={
                    [
                        TabPane('General', <General />),
                        TabPane('Tier List', <TierList />),
                        TabPane('Motes', <Motes />)
                    ]
                }
                />
            </TransitionContainer>
        )
    }
}